import GutterBlockTypes, { TABLE_ACTION_EVENT } from '../../../types/GutterBlockTypes';
import getTableColumnCountForCells from '../utils/getTableColumnCountForCells';
export default function makeSelectTableRow(store) {
  return {
    selectTableRow: function selectTableRow(editor, tableId, selectedRowIndex) {
      var cells = editor.getTableCells(tableId);
      var columnCount = getTableColumnCountForCells(cells);
      var nodeId = editor.getTable(tableId).key;
      editor.command('updateGutterBlock', {
        gutterBlockType: GutterBlockTypes.ALL_BLOCKS,
        nodeId: nodeId,
        priority: 0,
        origin: TABLE_ACTION_EVENT
      });
      var selectedCells = cells.filter(function (_cell, i) {
        return i >= selectedRowIndex * columnCount && i < selectedRowIndex * columnCount + columnCount;
      });
      var selectedCellKeys = selectedCells.map(function (cell) {
        return cell.key;
      });
      var selectedCellsCoords = editor.getCellsCoords(selectedCells);
      store.updateItem(store.getItem('lastFocusedTableId'), {});
      store.updateItem('lastFocusedTableId', tableId);
      store.updateItem(tableId, {
        selectedRowIndex: selectedRowIndex,
        selectedCellKeys: selectedCellKeys,
        selectedCellsCoords: selectedCellsCoords
      });
      return editor.snapshotSelection().withoutSaving(function () {
        return editor.deselect();
      });
    }
  };
}